import script from "./VitaShiftControl.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaShiftControl.vue?vue&type=script&lang=ts&setup=true"

import "./VitaShiftControl.vue?vue&type=style&index=0&id=78d0e4ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d0e4ca"]])

export default __exports__